import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal } from "@op/opds.opux-modal";
import { Button, ButtonRow } from "@op/opds.opux";
import { useMessage, Message, useMessageGetter } from "react-message-context";
import { withRouter } from "react-router-dom";

const QuitAction = ({ isSending, history }) => {
  const [open, setOpen] = useState(false);

  const modalMsgs = useMessageGetter("feedback.form.quit.modal");
  const link = useMessage("url.quit")();

  const renderFooter = () => (
    <ButtonRow className="rof-modal__footer">
      <Button id="ROF-cancelQuitButton" compact onClick={() => setOpen(!open)}>
        {modalMsgs("button.cancel")}
      </Button>
      <Button id="ROF-quitButton" compact onClick={() => history.push(link)}>
        {modalMsgs("button.quit")}
      </Button>
    </ButtonRow>
  );

  const handleAction = (e, isKeyPress) => {
    e.preventDefault();
    if (!isKeyPress || (isKeyPress && (e.key === "Enter" || e.key === " "))) {
      setOpen(!open);
    }
  };

  return (
    <>
      <Button
        id="ROF-quitAction"
        className="skip-link-interruption"
        alternate
        nonInteractive={isSending}
        onClick={(e) => handleAction(e, false)}
        onKeyPress={(e) => handleAction(e, true)}
      >
        <Message id="feedback.form.quit.button" />
      </Button>
      <Modal
        id="ROF-quitModal"
        appElement={document.getElementById("reportproblemopfi-main")}
        className="rof-modal"
        footer={renderFooter()}
        onUpdate={(state) => setOpen(state.open)}
        title={modalMsgs("title")}
        isOpen={open}
      >
        <div className="opux-v6__opds">
          <p>{modalMsgs("body")}</p>
        </div>
      </Modal>
    </>
  );
};

QuitAction.propTypes = {
  isSending: PropTypes.bool,
};

export default withRouter(QuitAction);
